import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link'];

  connect() {
    this.wide = window.matchMedia('(min-width: 1025px)');
    this.render = this.render.bind(this);
    this.wide.addListener(this.render);
    this.render();
  }

  disconnect() {
    this.wide.removeListener(this.render);
  }

  select(event) {
    const link = event.currentTarget;

    if (this.wide.matches) {
      event.preventDefault();
      if (!link.classList.contains('is-active')) this.activateOnly(link);
      return;
    }

    const active = link.classList.toggle('is-active');
    this.setIcon(link, active);
  }

  render() {
    if (this.wide.matches) {
      const active = this.linkTargets.find((link) =>
        link.classList.contains('is-active'),
      );
      if (active) this.activateOnly(active);
      else this.linkTargets[0]?.classList.add('is-active');
      return;
    }

    this.linkTargets.forEach((link) =>
      this.setIcon(link, link.classList.contains('is-active')),
    );
  }

  activateOnly(link) {
    this.linkTargets.forEach((el) =>
      el.classList.toggle('is-active', el === link),
    );
  }

  setIcon(link, active) {
    const icon = link.firstElementChild;
    if (!icon) return;
    icon.classList.toggle('fa-minus', active);
    icon.classList.toggle('fa-plus', !active);
  }
}
